<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('ScheduleLine.ScheduleLineQuery')}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="plant">
                                <p>{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                     <input :disabled ="disableFactory" type="radio" :name="'schLine_FactoryTypeOpt'" v-model="schLineQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                </div>
                            </div>
                            <div class="supplier">
                                <p>{{$t('OrderInfo_Vue.VendorId')}}：</p>
                                <input type="text" v-if="isDisableVendorId" :disabled="isDisableVendorId" v-model="schLineQueryParam.vendorId">
                                <Select2 style="width: 500px;" v-if="!isDisableVendorId" v-model="schLineQueryParam.vendorIdList" :options="memberListFilter(schLineQueryParam.factoryId)" :settings="{ 'multiple': 'true' }" />
                            </div>
                            <div class="order_month">
                                <p>{{$t('ScheduleLine.Month')}} ：</p>
                                <input type="radio" name="queryMonth" :value="'C'" v-model="schLineQueryParam.queryMonth"> {{$t('ScheduleLine.ThisMonth')}}
                                <input type="radio" name="queryMonth" :value="'N'" v-model="schLineQueryParam.queryMonth"> {{$t('ScheduleLine.NextMonth')}}
                            </div>
                            <div class="order_num">
                                <p>{{$t('OrderInfo_Vue.OrderNo')}}：</p>
                                <input type="text" maxlength="15"  v-model="schLineQueryParam.orderNo">
                            </div>
                            <div class="partNo">
                                <p>{{$t('ScheduleLine.Material')}} ：</p>
                                <input type="text" v-model="schLineQueryParam.matnr">
                            </div>
                            <div class="check">
                                <p>{{$t('ScheduleLine.DisplayConditions')}}：</p>
                                <input type="radio" name="displayCond" :value="'A'" v-model="schLineQueryParam.displayCond"> {{$t('ScheduleLine.OverdueUnpaidQuantity')}}
                                <input type="radio" name="displayCond" :value="'B'" v-model="schLineQueryParam.displayCond"> {{$t('ScheduleLine.ViewDeliveredQuantity')}}
                                <input type="radio" name="displayCond" :value="'C'" v-model="schLineQueryParam.displayCond"> {{$t('ScheduleLine.ViewUnpaidQuantity')}}
                                <input type="radio" name="displayCond" :value="''" v-model="schLineQueryParam.displayCond"> {{$t('ScheduleLine.AllData')}}
                            </div>
                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="schLineSearchEvent">{{$t('Buttons.Query')}}</button>
                                <!-- <button type="button" class="btn btn-success mr-2">{{$t('Buttons.Print')}}</button> -->
                                <button type="button" class="btn btn-info mr-2" @click="schLineExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            factoryList: this.$t('factoryVNList'), //廠別 清單
            schLineQueryParam : {
                factoryId : '',
                vendorIdList:[],
                queryMonth : 'C',
                displayCond: ''
            },
            isDisableVendorId : false
        }
    },
    props : {
    },
    methods: {
        schLineSearchEvent (){ //搜尋
            this.$emit('scheduleLineSearch', this.schLineQueryParam);
        },
        schLineExportEvent (){ //匯出
            const url = `${this.$apiUrl_Order}/PrepareSearchScheduleLineExport`;
            this.axios.post(url, this.schLineQueryParam).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Order}/SearchScheduleLineExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('scheduleLineExportExcel',urlExcel);
            })
        }
    },
    computed: {
        ...mapGetters(['lang']),
        disableFactory (){
            if(this.isMember){
                return true;
            }
            return false;
        }
    },
    watch: {
        "lang": function() {
            this.factoryList = this.$t('factoryVNList') //廠別 清單
        }
    },
	mounted() {
        let userInfo = this.$userInfo ;
        if(this.isMember){            
            this.schLineQueryParam.vendorId = userInfo.vendorId;
            this.isDisableVendorId =true;
        }
        this.schLineQueryParam.factoryId = this.$userInfo.userFactory;
        if(!this.isMember){
            this.initMemberList();
        }
        //--預設查詢
        this.schLineSearchEvent ();
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .plant, .supplier, .order_month, .date_range, .partNo, .order_num, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
        > div {
             margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
